import { ReactNode } from "react";
import { PropertyManagementSystem } from "shared/types/partner";

export interface Integration {
  id: string;
  name: string;
  icon: ReactNode;
}

export enum Step {
  FIRST,
  SECOND,
  THIRD
}

export enum IntegrationId {
  GA = "GA",
  HUBSPOT = "HUBSPOT",
  CODEBOX = "CODEBOX",
  SENTRILOCK = "SENTRILOCK",
  ZILLOW = "ZILLOW",
  ZUMPER = "ZUMPER",
  APARTMENTS_COM = "APARTMENTS_COM",
  MHVILLAGE = "MHVILLAGE",
  BOOM_FINANCE = "BOOM_FINANCE",
  META_ADS = "META_ADS"
}

export const isPmsIntegration = (id: string): id is PropertyManagementSystem =>
  (Object.values(PropertyManagementSystem) as string[]).includes(id) &&
  id !== PropertyManagementSystem.Other;

// Integrations that skip the credentials step (direct connect or no creds needed)
export const DIRECT_CONNECT_INTEGRATIONS = new Set<
  PropertyManagementSystem | IntegrationId
>([
  IntegrationId.ZILLOW,
  IntegrationId.ZUMPER,
  IntegrationId.APARTMENTS_COM,
  IntegrationId.MHVILLAGE,
  IntegrationId.BOOM_FINANCE
]);
